import React from "react";

const Textarea = ({
  value,
  onChange,
  placeholder,
  rows = 4,
  cols = 50,
  disable = false,
  error = false,
  className,
  helperText,
}) => {
  return (
    <>
      <div
        className={`flex flex-col justify-start items-start w-full gap-2.5 px-4 py-3 rounded-lg border text-sm text-[#142b70]/80 placeholder:text-[#142b70]/50
        ${disable ? "text-[#eee] border-[#999]/30" : ""}
        ${error ? "border-red-500" : "border-[#a48572]/50"}
        ${className ? className : ""}
      `}
      >
        <div className="flex justify-start items-center w-full gap-1">
          <textarea
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            rows={rows}
            cols={cols}
            disabled={disable}
            className={`w-full resize-none text-sm text-[#142b70] placeholder:text-[#142b70]/50 outline-none bg-transparent
            ${disable ? "text-[#999]" : ""}
          `}
          />
        </div>
      </div>
      {error && helperText && (
        <p className="text-xs text-red-600 mt-2">{helperText}</p>
      )}
    </>
  );
};

export default Textarea;
